import React from 'react'
import cn from 'classnames'
import { useModal } from 'hooks/useModal'
import { InfoModal } from 'components'
import { useTranslation } from 'react-i18next'
import classes from './Footer.module.scss'
import { PdfSupplier } from 'components/PdfSupplier/PdfSupplier'

interface PrivacyStatementModalProps {
  intraModal?: boolean
  label?: string
}

export const PrivacyStatementModal: React.FunctionComponent<
  PrivacyStatementModalProps
> = ({
  intraModal = false,
  label = 'components.footer.privacyStatementModal.buttonText',
}) => {
  const [showModal, openModal, closeModal] = useModal()
  const { t } = useTranslation()

  const link = intraModal ? (
    <u className={cn(classes.inlineLink)} onClick={openModal}>
      {t(label)}
    </u>
  ) : (
    <button
      className={cn(
        'wb-link',
        'wb-link--small',
        'wb-link--theme-dark',
        classes.button
      )}
      onClick={openModal}
    >
      {t(label)}
    </button>
  )

  return (
    <>
      {link}

      {showModal && (
        <InfoModal
          onClose={closeModal}
          headline={t('components.footer.privacyStatementModal.heading')}
        >
          <PdfSupplier
            filePath={
              process.env.PUBLIC_URL +
              '/Datenschutzhinweise_Website_MBAM_2025_04.pdf'
            }
            width={'100%'}
            height={'400px'}
            title={t('components.footer.privacyStatementModal.heading')}
          />
        </InfoModal>
      )}
    </>
  )
}
